<p>
  <a [href]="url" target="_blank">{{ url }}</a>
</p>

<p>
  <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="handleExportToExcelClick()" [disabled]="isExporting">
    <wl-busy *ngIf="isExporting" [show]="isExporting"></wl-busy>
    <span [hidden]="isExporting">{{ 'common.export' | translate | titlecase }}</span>
    <span [hidden]="!isExporting">{{ 'common.exporting' | translate | titlecase }}</span>
  </button>
</p>

<p-table [showGridlines]="true"
  [rows]="20"
  class="wl-responsive-prime-datatable"
  [value]="clickLogResult.Result"
  [paginator]="true"
  (onLazyLoad)="lazyLoad($event)"
  [totalRecords]="clickLogResult.TotalCount"
  [lazy]="true"
  [loading]="isSearching"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'ProfileId'" style="width: 120px">
        {{ 'communications.mass-comm-message-edit.analytics.click-details.profile-id-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'SendToDisplayName'">
        {{ 'communications.mass-comm-message-edit.analytics.click-details.recipient-name-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'SendTo'" class="wl-prime-datatable-hidden-phone">
        {{ 'communications.mass-comm-message-edit.analytics.click-details.email-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'TotalRead'" class="wl-prime-datatable-hidden-phone text-center" style="width: 180px">
        {{ 'communications.mass-comm-message-edit.analytics.click-details.click-count-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-click>
    <tr>
      <td>{{ click.ProfileId }}</td>
      <td>
        <div class="wl-prime-datatable-hidden-phone">{{ click.SendToDisplayName }}</div>
        <div class="wl-prime-datatable-hidden-tablet-and-bigger">
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.click-details.profile-id-column-header' | translate | titlecase
              }}:</strong
            >
            {{ click.ProfileId }}
          </div>
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.click-details.recipient-name-column-header' | translate | titlecase
              }}:</strong
            >
            {{ click.SendToDisplayName }}
          </div>
          <div>
            <strong
              >{{ 'communications.mass-comm-message-edit.analytics.click-details.email-column-header' | translate | titlecase }}:</strong
            >
            {{ click.SendTo }}
          </div>
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.click-details.click-count-column-header' | translate | titlecase
              }}:</strong
            >
            {{ click.TotalClicks }}
          </div>
        </div>
      </td>
      <td class="wl-prime-datatable-hidden-phone">
        <div style="overflow: hidden">{{ click.SendTo }}</div>
      </td>
      <td class="wl-prime-datatable-hidden-phone text-center">
        {{ click.TotalClicks }}
      </td>
    </tr>
  </ng-template>
</p-table>
